import { FormGroup } from "@angular/forms";

/* CLASSE RESPONSÁVEL PELOS MÉTODOS DE ERROS */
export class FormUtils {
   public constructor(private form: FormGroup) {}

        /**
     * showFieldError
     * MÉTODO RESPONSÁVEL PELOS ERROS DOS CAMPOS
     */
    public showFieldError(fieldName: string): boolean {

        let field = this.getField(fieldName);
        return field.invalid && (field.touched || field.dirty);
    }

    /**
     * fielClassForErrorOrSuccess
     * METODO RESPONSÁVEL POR COLOCAR AS CLASSES DE ERRO E SUCESSO
     */
    public fielClassForErrorOrSuccess(fieldName: string) {
        return{
            "is-invalid": this.showFieldError(fieldName),
            "is-valid":   this.getField(fieldName).valid
        }
    }

    /**
     * getField
     * fieldName: string  
     * METODO RESPONSÁVEL POR PEGAR O CAMPO DO ERRO   
     * */
    public getField(fieldName: string) {
        return this.form.get(fieldName);
    }
}


// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/shared/form.utils.ts